export const billboardSongs = [
  {
    id: 101,
    title: "Flowers",
    artist: "Miley Cyrus",
    album: "Endless Summer Vacation",
    year: 2023,
    genre: "Pop",
    language: "English",
    duration: "3:20",
    country: "USA",
    popularity: 98,
    spotifyId: "billboard_001",
    billboardRank: 1,
    weeksOnChart: 52
  },
  {
    id: 102,
    title: "Last Night",
    artist: "Morgan Wallen",
    album: "One Thing at a Time",
    year: 2023,
    genre: "Country",
    language: "English",
    duration: "2:44",
    country: "USA",
    popularity: 97,
    spotifyId: "billboard_002",
    billboardRank: 2,
    weeksOnChart: 45
  },
  {
    id: 103,
    title: "Vampire",
    artist: "Olivia Rodrigo",
    album: "GUTS",
    year: 2023,
    genre: "Pop",
    language: "English",
    duration: "3:40",
    country: "USA",
    popularity: 96,
    spotifyId: "billboard_003",
    billboardRank: 3,
    weeksOnChart: 38
  },
  {
    id: 104,
    title: "Kill Bill",
    artist: "SZA",
    album: "SOS",
    year: 2022,
    genre: "R&B",
    language: "English",
    duration: "2:33",
    country: "USA",
    popularity: 95,
    spotifyId: "billboard_004",
    billboardRank: 4,
    weeksOnChart: 62
  },
  {
    id: 105,
    title: "Anti-Hero",
    artist: "Taylor Swift",
    album: "Midnights",
    year: 2022,
    genre: "Pop",
    language: "English",
    duration: "3:21",
    country: "USA",
    popularity: 94,
    spotifyId: "billboard_005",
    billboardRank: 5,
    weeksOnChart: 48
  },
  {
    id: 106,
    title: "Unholy",
    artist: "Sam Smith & Kim Petras",
    album: "Gloria",
    year: 2022,
    genre: "Pop",
    language: "English",
    duration: "2:36",
    country: "UK",
    popularity: 93,
    spotifyId: "billboard_006",
    billboardRank: 6,
    weeksOnChart: 41
  },
  {
    id: 107,
    title: "As It Was",
    artist: "Harry Styles",
    album: "Harry's House",
    year: 2022,
    genre: "Pop",
    language: "English",
    duration: "2:47",
    country: "UK",
    popularity: 92,
    spotifyId: "billboard_007",
    billboardRank: 7,
    weeksOnChart: 55
  },
  {
    id: 108,
    title: "About Damn Time",
    artist: "Lizzo",
    album: "Special",
    year: 2022,
    genre: "Pop",
    language: "English",
    duration: "3:11",
    country: "USA",
    popularity: 91,
    spotifyId: "billboard_008",
    billboardRank: 8,
    weeksOnChart: 39
  },
  {
    id: 109,
    title: "Break My Soul",
    artist: "Beyoncé",
    album: "RENAISSANCE",
    year: 2022,
    genre: "R&B",
    language: "English",
    duration: "4:38",
    country: "USA",
    popularity: 90,
    spotifyId: "billboard_009",
    billboardRank: 9,
    weeksOnChart: 36
  },
  {
    id: 110,
    title: "Late Night Talking",
    artist: "Harry Styles",
    album: "Harry's House",
    year: 2022,
    genre: "Pop",
    language: "English",
    duration: "2:57",
    country: "UK",
    popularity: 89,
    spotifyId: "billboard_010",
    billboardRank: 10,
    weeksOnChart: 42
  },
  {
    id: 111,
    title: "Hold Me Closer",
    artist: "Elton John & Britney Spears",
    album: "The Lockdown Sessions",
    year: 2022,
    genre: "Pop",
    language: "English",
    duration: "3:35",
    country: "UK",
    popularity: 88,
    spotifyId: "billboard_011",
    billboardRank: 11,
    weeksOnChart: 28
  },
  {
    id: 112,
    title: "Shirt",
    artist: "SZA",
    album: "SOS",
    year: 2022,
    genre: "R&B",
    language: "English",
    duration: "3:01",
    country: "USA",
    popularity: 87,
    spotifyId: "billboard_012",
    billboardRank: 12,
    weeksOnChart: 31
  },
  {
    id: 113,
    title: "Super Freaky Girl",
    artist: "Nicki Minaj",
    album: "Queen Radio: Volume 1",
    year: 2022,
    genre: "Hip-Hop",
    language: "English",
    duration: "2:50",
    country: "USA",
    popularity: 86,
    spotifyId: "billboard_013",
    billboardRank: 13,
    weeksOnChart: 25
  },
  {
    id: 114,
    title: "Hold Me Closer",
    artist: "Elton John & Britney Spears",
    album: "The Lockdown Sessions",
    year: 2022,
    genre: "Pop",
    language: "English",
    duration: "3:35",
    country: "UK",
    popularity: 85,
    spotifyId: "billboard_014",
    billboardRank: 14,
    weeksOnChart: 22
  },
  {
    id: 115,
    title: "Vampire",
    artist: "Olivia Rodrigo",
    album: "GUTS",
    year: 2023,
    genre: "Pop",
    language: "English",
    duration: "3:40",
    country: "USA",
    popularity: 84,
    spotifyId: "billboard_015",
    billboardRank: 15,
    weeksOnChart: 18
  }
];

export const billboardGenres = [
  "Pop",
  "Hip-Hop",
  "R&B",
  "Country",
  "Rock",
  "Electronic",
  "Latin",
  "Alternative"
];

export const billboardLanguages = [
  "English",
  "Spanish",
  "French",
  "Korean",
  "Japanese"
]; 